import React, { Children } from "react"
import Logo from "../../../images/arden-university.png"
import mobileFormStyles from "./mobileform.module.css"
import moment from 'moment-timezone'

const MobileForm = ({ 
  children, 
  webinarTitle,
  formId,
  formWebinarTime,
  formPardotProgrammeCode,
  formWebinarKey,
  formGuestName
}) => {
  

  const isNull = (formfield) => {
    if(formfield === null)
    return String()
    else
    return formfield
    }

   const PARDOT_TIME_FORMAT = moment(formWebinarTime).format("YYYY-MM-DD")

  return(
  <div class={mobileFormStyles.form_wrapper_mobile}>
    <iframe
      className="PardotForm"
      src={`${formId}?Webinar_Date=${isNull(PARDOT_TIME_FORMAT) }&Webinar_Title=${isNull(webinarTitle)}&Webinar_Key=${isNull(formWebinarKey)}&Pardot_Programme_Code=${isNull(formPardotProgrammeCode) }&Webinar_Academics=${isNull(formGuestName)}`}
      style={{ width: "100%", height: "810px", border: 0 }}
      type="text/html"
      frameborder="0"
      allowTransparency="true"
    ></iframe>
  </div>
  )
}

export default MobileForm
